import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import PRow from 'shared/ui/prow';
import PCol from 'shared/ui/pcol';
import { CreateHeader, Footer } from 'shared/ui/dialog-header';
import { translate } from 'i18n/jhipster-language';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { createEntity as createReplacementRequest, clearMutationFlags, } from 'shared/lib/reducers/card-replacement-request.reducer';
import { getEntities as getCards } from 'shared/lib/reducers/card.reducer';
import { CARD_REPLACEMENT_DEFAULT_SOURCE_CHANNEL, CARD_REPLACEMENT_REASON_OPTIONS, } from 'shared/lib/card-replacement-form.constants';
import { buildAuthUserDisplayName } from 'shared/lib/auth-user-display';
import { useCardPickerSearch, toCardPickerOption, CARD_PICKER_ACTIVE_STATUS_QUERY } from 'features/cards/hooks/use-card-picker-search';
const CardReplacementRequestListCreateDialog = ({ visible, onHide, onCreated, updating, updateSuccess, account, cards, cardsLoading, submitRequest, clearFlags, loadCards, }) => {
    const [cardId, setCardId] = useState(null);
    const [selectedCardOption, setSelectedCardOption] = useState(null);
    const [reason, setReason] = useState(null);
    const [touchedSubmit, setTouchedSubmit] = useState(false);
    const { onFilter: onCardFilter } = useCardPickerSearch(visible, loadCards, CARD_PICKER_ACTIVE_STATUS_QUERY);
    const cardOptions = useMemo(() => {
        const opts = cards
            .map(toCardPickerOption)
            .filter((o) => o != null);
        if (selectedCardOption && !opts.some(o => o.id === selectedCardOption.id)) {
            return [selectedCardOption, ...opts];
        }
        return opts;
    }, [cards, selectedCardOption]);
    useEffect(() => {
        if (!visible) {
            setCardId(null);
            setSelectedCardOption(null);
            setReason(null);
            setTouchedSubmit(false);
            return;
        }
        clearFlags();
    }, [visible, clearFlags]);
    useEffect(() => {
        if (!updateSuccess)
            return;
        onCreated?.();
        clearFlags();
        onHide();
    }, [updateSuccess, clearFlags, onCreated, onHide]);
    const onSubmit = (e) => {
        e.preventDefault();
        setTouchedSubmit(true);
        if (cardId == null || cardId < 1 || !reason)
            return;
        const performedBy = buildAuthUserDisplayName(account ?? {})?.trim() || undefined;
        submitRequest({
            oldCardId: cardId,
            reason,
            sourceChannel: CARD_REPLACEMENT_DEFAULT_SOURCE_CHANNEL,
            ...(performedBy ? { performedBy } : {}),
        });
    };
    const reasonInvalid = touchedSubmit && !reason;
    const cardInvalid = touchedSubmit && (cardId == null || cardId < 1);
    return (_jsx(Dialog, { visible: visible, onHide: onHide, dismissableMask: true, style: { width: '640px', marginTop: '2rem' }, showHeader: false, children: _jsxs("div", { className: "p-mt-2", style: { maxHeight: '80vh', overflowY: 'auto' }, children: [_jsx(PCol, { children: _jsx(PRow, { justify: "between", className: "p-mb-2 p-mt-3", children: _jsx(CreateHeader, { headername: translate('entity.action.create', {
                                entity: translate('form.cardReplacementRequest'),
                            }) }) }) }), _jsx(PCol, { children: _jsxs("form", { onSubmit: onSubmit, children: [_jsxs(PRow, { children: [_jsxs(PCol, { col: 12, className: "p-field", children: [_jsxs("label", { htmlFor: "standalone-replacement-card", children: [translate('form.card'), " *"] }), _jsx(Dropdown, { inputId: "standalone-replacement-card", id: "standalone-replacement-card", className: classNames('w-full', { 'p-invalid': cardInvalid }), options: cardOptions, optionLabel: "label", optionValue: "id", value: cardId, onChange: e => {
                                                    const nextId = e.value;
                                                    setCardId(nextId);
                                                    if (nextId == null) {
                                                        setSelectedCardOption(null);
                                                        return;
                                                    }
                                                    const picked = cardOptions.find(o => o.id === nextId);
                                                    if (picked) {
                                                        setSelectedCardOption(picked);
                                                    }
                                                }, onFilter: onCardFilter, filter: true, filterBy: "label", showClear: true, placeholder: cardsLoading ? translate('form.loading') : undefined }), cardInvalid ? (_jsx("small", { className: "p-error", children: translate('form.validation.required') })) : null] }), _jsxs(PCol, { col: 12, className: "p-field", children: [_jsxs("label", { htmlFor: "standalone-replacement-reason", children: [translate('form.replacementReason'), " *"] }), _jsx(Dropdown, { inputId: "standalone-replacement-reason", id: "standalone-replacement-reason", className: classNames('w-full', { 'p-invalid': reasonInvalid }), options: CARD_REPLACEMENT_REASON_OPTIONS, optionLabel: "name", optionValue: "value", value: reason, onChange: e => setReason(e.value), showClear: true }), reasonInvalid ? (_jsx("small", { className: "p-error", children: translate('form.validation.required') })) : null] })] }), _jsx(Footer, { closeDialog: onHide, className: "p-py-1", updating: updating })] }) })] }) }));
};
const mapState = ({ cardReplacementRequest, cmsAccount, card, }) => ({
    updating: cardReplacementRequest.updating,
    updateSuccess: cardReplacementRequest.updateSuccess,
    account: cmsAccount.account,
    cards: card.entities,
    cardsLoading: card.loading,
});
const mapDispatch = (dispatch) => ({
    submitRequest: body => dispatch(createReplacementRequest(body)),
    clearFlags: () => dispatch(clearMutationFlags()),
    loadCards: (params) => dispatch(getCards(params)),
});
export default connect(mapState, mapDispatch)(CardReplacementRequestListCreateDialog);
